<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("seatlayout") }}</div>
      </div>
    </div>

    <div class="white-wrapper mt-3">
      <div>
        <div class="row">
          <div class="col-md-6 col-lg-4 col-xl-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="selecteCinema.length > 0 ? 'shift-up' : ''">{{
                $t("selectCinema")
              }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selecteCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  @click="
                    OnSelectCinema(
                      $event,
                      cinema.cine_id,
                      cinema.cine_name,
                      cinema
                    )
                  "
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div v-if="selecteCinema" class="col-md-6 col-lg-8 col-xl-8">
            <div class="col-md-6 col-lg-4 col-xl-4 float-right">
              <b-form-input
                v-debounce:300="searchSeatLayout"
                v-model="searchValue"
                placeholder="Search..."
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="pt-3">
        <div class="row">
          <div
            v-for="(screen, screenIndex) in Screens"
            :key="screenIndex"
            class="col-md-3 mb-3"
          >
            <div class="seat-layout-box">
              <div class="p-2 text-center border-bottom">
                {{ screen.screen_name }}
                {{ screen.formatName ? +" | " + screen.formatName : "" }}
              </div> -->
      <!-- {{  screen.seatlayoutflag }} -->
      <!-- <img
                v-if="screen.seatlayoutflag"
                class="w-100 p-2"
                src="@/assets/img/capture.png"
                alt
              /> -->

      <!-- <div v-if="screen.seatlayoutflag" class="border-top p-3">
                <div class="row justify-content-center">
                  <div class="col-4">
                    <b-button
                      :to="'view-seat-layout/' + screen.screen_id"
                      class="btn btn-primary btn-sm min-width-auto"
                      >{{ $t("view") }}</b-button
                    >
                  </div>
                  <div
                    class="col-4"
                    v-if="
                      screen.isEdit && cinema_manager_add_edit_disabled != 3 && $can('update', 'Seat Layout')
                    "
                  >
                    <b-button
                      class="btn btn-primary btn-sm min-width-auto"
                      :to="'edit-seat-layout/' + screen.screen_id"
                      >{{ $t("edit") }}</b-button
                    >
                  </div>
                  <div
                    class="col-4 pl-0"
                    v-if="cinema_manager_add_edit_disabled != 3"
                  >
                    <b-button
                      :to="'broken-seat-layout/' + screen.screen_id"
                      class="btn btn-primary btn-sm min-width-auto"
                      >{{ $t("others") }}</b-button
                    >
                  </div>
                </div>
              </div>

              <div
                v-if="!screen.seatlayoutflag"
                class="text-center border-top py-3"
              >
                <b-button
                  v-if="cinema_manager_add_edit_disabled != 3"
                  :to="'add-seat-layout/' + screen.screen_id"
                  class="btn btn-primary btn-sm"
                  >{{ $t("add") }}</b-button
                >
              </div>
            </div>
          </div>

          <div class="col-12" v-if="Screens.length == 0">
            <NoRecords />
          </div>
        </div>
      </div> -->
      <div class="white-wrapper mt-5" style="padding: 10px 25px">
        <table class="list-view-table mt-1 mb-1" v-if="listView">
          <thead>
            <tr>
              <th class="text-left" style="width: 150px">Status</th>
              <th class="text-center" style="width: 200px">Screen ID</th>
              <th class="text-left ml-5"><span> </span> Screen Name</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(screen, screenIndex) in Screens"
              :key="screenIndex"
              class="light_grey_back"
            >
              <td>
                <div class="">
                  <div v-if="screen.seatlayoutflag" class="">
                    <div class="row justify-content-start">
                      <div class="col-2">
                        <router-link
                          :to="'view-seat-layout/' + screen.screen_id"
                          class="btn blue-icon"
                          v-b-tooltip="'View'"
                          tabindex="0"
                        >
                          <i class="icon-eye icon blue-icon"></i>
                        </router-link>
                      </div>
                      <div
                        class="col-2"
                        v-if="
                          screen.isEdit &&
                            cinema_manager_add_edit_disabled !== 3 &&
                            $can('update', 'Seat Layout')
                        "
                      >
                        <router-link
                          :to="'edit-seat-layout/' + screen.screen_id"
                          class="btn blue-icon"
                          v-b-tooltip="'Edit'"
                          tabindex="0"
                        >
                          <i class="edit-pen icon blue-icon cursor-pointer"></i>
                        </router-link>
                      </div>
                      <div
                        class="col-2"
                        v-if="cinema_manager_add_edit_disabled !== 3"
                      >
                        <router-link
                          :to="'broken-seat-layout/' + screen.screen_id"
                          class="btn"
                          v-b-tooltip="'Others'"
                          tabindex="0"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#8d6fbf"
                            class="bi bi-list"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                            />
                          </svg>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!screen.seatlayoutflag"
                    class="text-center border-top py-3"
                  >
                    <router-link
                      v-if="cinema_manager_add_edit_disabled !== 3"
                      :to="'add-seat-layout/' + screen.screen_id"
                      class="btn"
                      v-b-tooltip="'Add'"
                      tabindex="0"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#8d6fbf"
                        class="bi bi-plus"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                        />
                      </svg>
                    </router-link>
                  </div>
                </div>
              </td>
              <td class="text-center">
                {{ screen.screen_id }}
              </td>
              <td class="text-left">
                <div class="p-2 text-left">
                  {{ screen.screen_name }}
                  <span v-if="screen.formatName">
                    | {{ screen.formatName }}</span
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="col-12" v-if="Screens.length === 0">
          <NoRecords />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CinemasService from "@/services/CinemasService";
  import MasterService from "@/services/MasterService";
  import NoRecords from "@/components/Partials/NoRecords.vue";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        select_cinema_message: true,
        cinema_manager_add_edit_disabled: null,
        searchCinema: "",
        isRoleID: true,
        getitem: "",
        Cinemas: [],
        CinemasCopy: [],
        selecteCinema: "",
        selecteCinemaId: "",
        Formats: [],
        FormatsMethod: {
          GET: "/admin/",
          tableName: "ms_movie_formats",
          urlKey: "",
        },
        ScreenSeatlayoutIds: [],
        Screens: [],
        debounce: null,
        searchValue: "",
        listView: true,
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      this.cinema_manager_add_edit_disabled = roleid;
      if (true) {
        this.isRoleID = false;
      }
      this.getCinemas(obj);
      this.getMovieFormats();
      this.getScreenSeatlayoutIds();
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.selecteCinema = CinemaObj.cine_name;
        this.selecteCinemaId = CinemaObj.cine_id;
      }
    },
    mounted() {},
    methods: {
      searchSeatLayout: function() {
        this.OnSelectCinema(
          null,
          this.selecteCinemaId,
          this.selecteCinema,
          null
        );
      },
      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      getCinemas: function(cine_id) {
        let payload = null;
        cine_id == null
          ? (payload = { tableName: "ms_cinemas", cine_is_active: "Y" })
          : (payload = {
              tableName: "ms_cinemas",
              cine_is_active: "Y",
              cine_id: cine_id,
            });
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.selectedCinema = x.cine_name;
                  this.OnSelectCinema(null, x.cine_id, x.cine_name, null);
                }
              });
            } else {
              // Error Message
              this.$toasted.show(data.message);
              console.log("show error1 :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error2 :", error);
          });
      },
      getMovieFormats: function() {
        this.Formats = [];
        let body = this.getRequestBody("GET", undefined, this.FormatsMethod);
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Formats = data.Records;
              } else {
                this.customErrors.message = data.message;
              }
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getScreenSeatlayoutIds: function() {
        CinemasService.GetScreenSeatlayoutIds()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ScreenSeatlayoutIds = data.Records;
              let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
              if (CinemaObj) {
                this.selecteCinema = CinemaObj.cine_name;
                this.selecteCinemaId = CinemaObj.cine_id;
                this.OnSelectCinema(
                  null,
                  this.selecteCinemaId,
                  this.selecteCinema,
                  CinemaObj
                );
              }
            } else {
              // Error Message
              console.log("show error1 :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error2 :", error);
          });
      },
      getCountOfScreenLayout: function(screen_id) {
        let payload = {
          screen_id: screen_id,
        };
        CinemasService.GetCountOfScreen(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              let count = data.Records[0].seatbooked_count;
              this.Screens = this.Screens.map((x) => {
                x["isEdit"] = true;
                console.log(
                  "x.screen_id, screen_id, count > 0 :",
                  x.screen_id,
                  screen_id,
                  count > 0
                );
                if (x.screen_id == screen_id && count > 0) {
                  x["isEdit"] = false;
                }
                return x;
              });
            } else {
              this.$toasted.show(data.message);
            }
            console.log(" this.Screens  :", this.Screens);
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      // Select Handler
      OnSelectCinema: function(event, cine_id, cine_name, cinema) {
        let loader = "";
        loader = this.$loading.show();

        this.Screens = [];
        this.select_cinema_message = false;
        this.selecteCinema = cine_name;
        this.selecteCinemaId = cine_id;
        if (event) {
          this.$store.dispatch("selectDropdownCinema", cinema);
        }
        let body = {
          activekey: "",
          conditionColName: "cinema_id",
          conditionId: cine_id,
          searchValue: this.searchValue,
          columnName: "screen_name",
          orderBy: "ASC",
          checkNewSeatLayout: true,
        };
        CinemasService.GetActiveScreenByCinema(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Screens = data.Records.filter((x) => x.screen_is_active);
              this.Screens.sort((a, b) => {
                return a.screen_id - b.screen_id;
              });
              this.Screens.map((x) => {
                x["isEdit"] = true;
                if (x.seatbooked_count > 0 || x.schedule_count > 0) {
                  x["isEdit"] = false;
                }
                let formatArray = this.Formats.filter(
                  (y) => y.mf_id === x.screen_format_id
                );
                let seatlayoutArray = this.ScreenSeatlayoutIds.filter(
                  (z) => z.screen_id === x.screen_id
                );
                if (formatArray.length > 0) {
                  x["formatName"] = formatArray[0].mf_name || "";
                } else {
                  x["formatName"] = "";
                }
                if (seatlayoutArray.length > 0) {
                  x["seatlayoutflag"] = true;
                } else {
                  x["seatlayoutflag"] = false;
                }
                return x;
              });
              console.log("this.Screens :", this.Screens);
            } else {
              // Error Message
              console.log("show error1 :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error2 :", error);
          })
          .finally(() => loader.hide());
      },
      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
    },
  };
</script>

<style>
  .seat-layout-header {
    width: 100%;
    position: -webkit-sticky;
    position: sticky;
    font-weight: bold;
    height: 70px;
    padding: 0 30px;
    border-bottom: 1px solid #d3d3d3;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 99;
  }

  .seat-layout-box {
    width: 100%;
    border: 1px solid #d3d3d3;
    border-radius: 15px;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/seatLayout.vue